import dayjs from "dayjs";
import { CurriculumsWithString, DataTypesWithString, GradesWithString } from "../../api/product";
export const mixpanelEvent = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    try {
        if (window.mixpanel) {
            window.mixpanel.track(...args);
        }
    } catch (e) {
        ;
    }
};
//Signup login
export function signupCompleted(property) {
    if (property["Login Method"] === "phone") {
        try {
            if (window.mixpanel) {
                window.mixpanel.alias(property.user_id);
                window.mixpanel.track("Sign Up Completed");
            }
            //네이버
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "//wcs.naver.net/wcslog.js";
            document.body.appendChild(script);
            const wcsScript1 = document.createElement("script");
            wcsScript1.src = "//wcs.naver.net/wcslog.js";
            wcsScript1.async = true;
            wcsScript1.onload = function() {
                const nasaScript1 = document.createElement("script");
                nasaScript1.innerHTML = '\n          var _nasa = {};\n          if (window.wcs) _nasa["cnv"] = wcs.cnv("2","0");\n        ';
                document.head.appendChild(nasaScript1);
            };
            document.head.appendChild(wcsScript1);
        } catch (e) {
            ;
        }
    } else if (property["Login Method"] === "kakao") {
        try {
            if (window.mixpanel) {
                window.mixpanel.alias(property.user_id);
                window.mixpanel.track("Sign Up Completed");
            }
            //네이버
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "//wcs.naver.net/wcslog.js";
            document.body.appendChild(script);
            const wcsScript1 = document.createElement("script");
            wcsScript1.src = "//wcs.naver.net/wcslog.js";
            wcsScript1.async = true;
            wcsScript1.onload = function() {
                const nasaScript1 = document.createElement("script");
                nasaScript1.innerHTML = '\n          var _nasa = {};\n          if (window.wcs) _nasa["cnv"] = wcs.cnv("2","0");\n        ';
                document.head.appendChild(nasaScript1);
            };
            document.head.appendChild(wcsScript1);
        } catch (e) {
            ;
        }
    }
}
export function loginCompleted(property) {
    try {
        if (window.mixpanel) {
            window.mixpanel.identify(property.user_id) //distinct id 설정
            ;
            window.mixpanel.people.set_once({
                ...property
            });
            window.mixpanel.track("Login Completed");
        }
    } catch (e) {
        ;
    }
}
export function productDetailPageViewed(property) {
    var _property_source, _property_source1, _property_source2;
    const sourceType = property.source_type;
    const handout = property.source;
    const textbook = property.source;
    const isEditable = !!handout && handout.studio_version === "v2";
    const item = {
        "Product ID": property.id,
        Price: property.price,
        "Product Name": property.title,
        "Product Category": property.source_type,
        "Product Type": sourceType === "handout" ? DataTypesWithString[handout.category] : null,
        "Product Subject": (_property_source = property.source) === null || _property_source === void 0 ? void 0 : _property_source.subject,
        "Product Curriculum": CurriculumsWithString[(_property_source1 = property.source) === null || _property_source1 === void 0 ? void 0 : _property_source1.curriculum],
        "Product Grade": GradesWithString[(_property_source2 = property.source) === null || _property_source2 === void 0 ? void 0 : _property_source2.grade],
        "Product Author": property.author,
        "Product Publisher": sourceType === "handout" ? null : textbook === null || textbook === void 0 ? void 0 : textbook.publisher_id.toString(),
        "Product Based License": sourceType === "handout" ? handout === null || handout === void 0 ? void 0 : handout.based_textbook_title : null,
        "Product Based License Type": sourceType === "handout" ? handout === null || handout === void 0 ? void 0 : handout.base_source_type : null,
        "Parsing-badge": isEditable
    };
    try {
        if (window.mixpanel) {
            window.mixpanel.track("Product Detail Page Viewed", {
                ...item
            });
        }
    } catch (e) {
        ;
    }
}
export function productDetailTimeSpent() {
    try {
        if (window.mixpanel) {
            window.mixpanel.time_event("Product Detail Page time spent");
        }
    } catch (e) {
        ;
    }
}
export function noteTimeSpent() {
    try {
        if (window.mixpanel) {
            window.mixpanel.time_event("[Note] Session Length in Viewer");
        }
    } catch (e) {
        ;
    }
}
export function noteClassStartTimeSpent() {
    try {
        if (window.mixpanel) {
            window.mixpanel.time_event("[Note] Class Clicked");
        }
    } catch (e) {
        ;
    }
}
export function productAddedToCart(property) {
    var _property_source, _textbook_publisher_id;
    const sourceType = property.source_type;
    const handout = property.source;
    const textbook = property.source;
    const item = {
        "Product ID": property.id,
        // Price: property.property_variants.find((item) => item.options.label === '라이선스').price,
        "Product Name": property.title,
        "Product Category": property.source_type,
        "Product Type": sourceType === "handout" ? handout.category : null,
        "Product Subject": ((_property_source = property.source) === null || _property_source === void 0 ? void 0 : _property_source.subject) || property.subject,
        "Product Curriculum": sourceType === "handout" ? CurriculumsWithString[handout.curriculum] : null,
        "Product Grade": sourceType === "handout" ? GradesWithString[handout.grade] : null,
        "Product Author": property.author,
        "Product Publisher": sourceType === "handout" ? null : textbook === null || textbook === void 0 ? void 0 : (_textbook_publisher_id = textbook.publisher_id) === null || _textbook_publisher_id === void 0 ? void 0 : _textbook_publisher_id.toString(),
        "Product Based License": sourceType === "handout" ? handout.based_textbook_title : null,
        "Product Based License Type": sourceType === "handout" ? handout.base_source_type : null,
        "Order Type": "일반",
        "Product Variant": "라이선스",
        "Parsing Badge": sourceType === "handout" ? handout.studio_version === "v2" : null,
        "relative products": property.relativeProducts,
        "Purchase option": property.purchaseOption,
        "Is Delivery": property.isDelivery
    };
    try {
        if (window.mixpanel) {
            // mx-43
            window.mixpanel.track("Product Added to Cart", {
                ...item
            });
        }
    } catch (e) {
        ;
    }
}
export function purchasedProduct(property) {
    //네이버
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//wcs.naver.net/wcslog.js";
    document.body.appendChild(script);
    const wcsScript1 = document.createElement("script");
    wcsScript1.src = "//wcs.naver.net/wcslog.js";
    wcsScript1.async = true;
    wcsScript1.onload = function() {
        const nasaScript1 = document.createElement("script");
        nasaScript1.innerHTML = '\n          var _nasa = {};\n          if (window.wcs) _nasa["cnv"] = wcs.cnv("3","0");\n        ';
        document.head.appendChild(nasaScript1);
    };
    document.head.appendChild(wcsScript1);
    for(let i = 0; i < property.length; i++){
        try {
            if (window.mixpanel) {
                window.mixpanel.track("Purchased Product", {
                    "Product ID": property[i].product_id,
                    "Product Category": property[i].product.source_type,
                    "Product Name": property[i].product.title,
                    Price: property[i].price,
                    // 'Product Sourcce': property[i].product.,
                    "Product Author": property[i].product.author,
                    "Product Variant": property[i].product_variant.options.label,
                    "Order Type": "일반",
                    // @ts-ignore
                    "Source Product ID": property[i].source_product_id,
                    // @ts-ignore
                    "Source Product Title": property[i].source_product_title
                });
            }
        } catch (e) {
            ;
        }
    }
}
export function userLogout() {
    try {
        if (window.mixpanel) {
            window.mixpanel.reset();
            window.mixpanel.track("Logout");
        }
    } catch (e) {
        ;
    }
}
//productDetail
export const productDetailPageScrolled = (property)=>{
    try {
        if (window.mixpanel) {
            window.mixpanel.track("Product Detail Page Scrolled", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const searchBarEvent = (param)=>{
    let { keyword , search_type  } = param;
    // const totalCount = useSearchStore?.getState()?.totalCount || 0
    try {
        if (window.mixpanel) {
            window.mixpanel.track("Searched from Search-bar", {
                "Search Term": keyword,
                "Search Category": search_type
            });
        }
    } catch (e) {
        ;
    }
};
const calculateAgeGroup = (birthYear)=>{
    const currentYear = dayjs().year();
    const age = currentYear - Number(birthYear);
    if (age < 14) {
        return "under_14";
    } else if (age < 19) {
        return "minor_14_19";
    }
    return "adult_19_plus";
};
export const updateUserInfoMixpanel = (param)=>{
    let { userProfile , userId  } = param;
    try {
        if (window.mixpanel) {
            window.mixpanel.identify(userId);
            window.mixpanel.people.set_once({
                "User Type": userProfile.userType,
                "Main Subject": userProfile.subject,
                "School Name": userProfile.school.map((item)=>item.name).join(","),
                "Age Group": calculateAgeGroup(userProfile.birth)
            });
            // 마케팅 수신 동의 여부 — false→true로 바뀔 수 있어 set_once가 아닌 set 사용
            if (userProfile.promotionAgreed !== undefined) {
                window.mixpanel.people.set({
                    promotion_agreed: userProfile.promotionAgreed
                });
            }
        }
    } catch (e) {
        ;
    }
};
// 마케팅 수신 동의 여부(promotion_agreed) 유저 프로필 속성만 갱신.
// 가입완료 페이지에서 거부자가 동의로 전환되는 등 값 변경 시점에 호출.
export const setPromotionAgreedProfile = (promotionAgreed)=>{
    try {
        if (window.mixpanel) {
            window.mixpanel.people.set({
                promotion_agreed: promotionAgreed
            });
        }
    } catch (e) {
        ;
    }
};
// PassUpgrade Events (MX-390~395)
export const planListViewed = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-390
            window.mixpanel.track("Plan List Viewed", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const planListClicked = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-391
            window.mixpanel.track("Plan List Clicked", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const planPageViewed = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-392
            window.mixpanel.track("Plan Page Viewed", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const planPageItemDetailInfo = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-393
            window.mixpanel.track("Plan Page Item Detail Info", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const planItemMoreButtonClicked = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-394
            window.mixpanel.track("Plan Item More Button Clicked", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const planUpgradeButtonClicked = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-395
            window.mixpanel.track("Plan Item Upgrade Button Clicked", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
// Checkout Popup Events (MX-396~399)
export const checkoutPopupViewed = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-396, mx-398
            window.mixpanel.track("Popup Viewed", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const checkoutPopupButtonClicked = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-397, mx-399
            window.mixpanel.track("Popup Button Clicked", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
// Library Download Events (MX-400~430)
export const myProductClicked = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-400
            window.mixpanel.track("My Product Clicked", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const handoutDownloadButtonClicked = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-410
            window.mixpanel.track("Handout Download Button Clicked", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const handoutDownloadStart = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-411, mx-418, mx-427
            window.mixpanel.track("Handout Download Start", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const popupViewed = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-401~407, mx-412, mx-414~416, mx-419, mx-421, mx-423, mx-425, mx-428
            window.mixpanel.track("Popup Viewed", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const popupButtonClicked = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-402~409, mx-413, mx-415, mx-417, mx-420, mx-422, mx-424, mx-426, mx-429
            window.mixpanel.track("Popup Button Clicked", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const closeOnOverlayClick = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-430
            window.mixpanel.track("Close on overlay click", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
// 정보입력(프로필 설정) 팝업 노출 (MX-636)
export const profileSettingPopupViewed = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-636
            window.mixpanel.track("Popup Viewed", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
// 가입완료 혜택 페이지 Events (MX-637~643)
export const signupCompletePageViewed = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-637(동의자), mx-640(거부자)
            window.mixpanel.track("Signup Complete Page Viewed", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const signupCompletePageButtonClicked = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-638(동의자), mx-641(거부자)
            window.mixpanel.track("Signup Complete Page Button Clicked", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
export const signupCompletePopupViewed = (property)=>{
    try {
        if (window.mixpanel) {
            // mx-639/642(혜택 지급 완료), mx-643(마케팅 수신 동의 완료)
            window.mixpanel.track("Popup Viewed", {
                ...property
            });
        }
    } catch (e) {
        ;
    }
};
